// Testimonials.js

import React from 'react';
import Slider from 'react-slick';
import './Testimonials.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    quote: "Brandon and his team are amazing. Always on time, and my lawn has never looked better.",
    author: "Sarah M., Bradenton"
  },
  {
    quote: "Great communication and professional service. Highly recommended!",
    author: "Tom R., Palma Sola"
  },
  {
    quote: "We’ve used Neighborhood Buzz for our rental property and couldn’t be happier.",
    author: "Dana L., AMI"
  },
  {
    quote: "The yard looks amazing after Brandon’s crew comes through.",
    author: "Mike S., Holmes Beach"
  },
  {
    quote: "Always responsive, friendly, and thorough. I recommend them to everyone.",
    author: "Lisa G., Cortez"
  }
];

const Testimonials = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  };

  return (
    <section id="testimonials" className="testimonials-section">
      <h2 className="testimonials-title">
        What Our Customers Are Saying <span role="img" aria-label="bee">🐝</span>
      </h2>
      <Slider {...settings}>
        {testimonials.map((t, index) => (
          <div key={index} className="testimonial-card">
            <span className="bee-icon" role="img" aria-label="bee">🐝</span>
            <p className="testimonial-quote">“{t.quote}”</p>
            <p className="testimonial-author">— {t.author}</p>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Testimonials;





